import { hydratePaymentPartition } from '../../filters/duck-filters';
import { handleNonJsonResponseHandler } from '../selexp-api-base-query';
import { selexpEarningsApiDuck } from '../selexp-earnings-api-duck';
import { TPaymentPartition, TPaymentDocument, TPaymentSummary } from './types-earnings';

const urlBase = '/NewEarnings';

export const earningsApiDuck = selexpEarningsApiDuck.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentPartitions: builder.query<TPaymentPartition[], { fiscalYearId: string; personnelNumber: number }>({
      query: (payload) => ({
        url: `${urlBase}/GetPaymentPartitions`,
        method: 'GET',
        noFilters: true,
        responseHandler: handleNonJsonResponseHandler,
        customParams: {
          fiscalYearId: payload.fiscalYearId,
        },
      }),
    }),
    getPayoutDocument: builder.query<TPaymentDocument, { documentId: string; personnelNumber: number }>({
      query: (payload) => ({
        url: `${urlBase}/GetPayoutDocument`,
        customParams: {
          documentId: payload.documentId,
        },
        method: 'GET',
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(hydratePaymentPartition(data));
        } catch {
          // no-op
        }
      },
    }),
    getPayoutSummary: builder.query<TPaymentSummary, any>({
      query: () => ({
        url: `${urlBase}/GetPayoutSummary`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetPaymentPartitionsQuery, useGetPayoutDocumentQuery, useGetPayoutSummaryQuery } = earningsApiDuck;
